module.exports = require("./../../_gen/openfl/media/SoundChannel");